'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./polyfill');

var _intlMessageformat = require('intl-messageformat');

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _bowser = require('bowser');

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var browser = _bowser2.default.getParser(window.navigator.userAgent);

var IotIntl = function () {
  function IotIntl() {
    var _this = this;

    _classCallCheck(this, IotIntl);

    Object.defineProperty(this, 'reset', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.loadDefaultMsg(_this.currentLocale);
      }
    });
    Object.defineProperty(this, 'register', {
      enumerable: true,
      writable: true,
      value: function value(appName) {
        if (!appName) {
          return;
        }

        var messageObj = window[appName];
        if (!messageObj) {
          return;
        }

        var default_locale_key = 'en_US';
        var defaultMessages = messageObj[default_locale_key] || {};

        var locale_key = _this.getLocaleKey();
        var messages = Object.assign(defaultMessages, messageObj[locale_key] || {});

        _this.addMessages(messages);
      }
    });
    Object.defineProperty(this, 'addMessages', {
      enumerable: true,
      writable: true,
      value: function value(messages) {
        _this.AllMessages = Object.assign(_this.AllMessages, messages || {});
      }
    });
    Object.defineProperty(this, 'getLocale', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.currentLocale;
      }
    });
    Object.defineProperty(this, 'setLocale', {
      enumerable: true,
      writable: true,
      value: function value(locale) {
        if (locale === _this.currentLocale) {
          return;
        }

        if (['en', 'zh', 'ja', 'jp'].includes(locale)) {
          _this.currentLocale = locale;
          _this.loadDefaultMsg(_this.currentLocale);
        } else {
          console.warn('locale is not invalid: ', locale);
          _this.currentLocale = 'zh';
        }
      }
    });
    Object.defineProperty(this, 'getLocaleKey', {
      enumerable: true,
      writable: true,
      value: function value() {
        var locale_key = '';
        switch (_this.currentLocale) {
          case 'en':
            locale_key = 'en_US';
            break;
          case 'zh':
            locale_key = 'zh_CN';
            break;
          case 'ja':
          case 'jp':
            locale_key = 'ja_JP';
            break;
          default:
            break;
        }
        return locale_key;
      }
    });
    Object.defineProperty(this, 'formatDate', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!date) return '';

        var time = null;
        try {
          // 使用 moment 对参数先做一次处理，避免自己实现不同的时间格式处理逻辑
          time = (0, _momentTimezone2.default)(date);
        } catch (e) {
          console.warn('parse date failed:', date);
          return '';
        }

        var locale = _this.currentLocale || 'zh';
        var defaultOpt = _this.dateOptions[locale] || _this.dateOptions.zh;
        var opts = Object.assign(defaultOpt, options);

        try {
          var dateTimeFormat = new Intl.DateTimeFormat(locale, opts);
          var currentTime = dateTimeFormat.format(time.toDate());

          // chromium & Edge bug
          // https://bugs.chromium.org/p/chromium/issues/detail?spm=a2o8d.corp_prod_issue_detail_v2.0.0.15b91966aXeV8A&id=1166288
          if (locale === 'zh') {
            // 满足这种模式 "2021/02/0114:32:43"
            if (/^\d{4}\/\d{2}\/\d{4}:\d{2}:\d{2}$/.test(currentTime)) {
              // 在第10位加一个空格
              currentTime = currentTime.slice(0, 10) + ' ' + currentTime.slice(10);
            }
          }

          var millisecond = time.millisecond();
          return millisecond ? currentTime + '.' + millisecond : currentTime;
        } catch (err) {
          // eslint-disable-next-line
          console.error(err);
          return '';
        }
      }
    });
    Object.defineProperty(this, 'msg', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        var _value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var msg = _this.AllMessages[id] || '';
        try {
          var messageFormat = new _intlMessageformat2.default(msg, _this.currentLocale);
          msg = messageFormat.format(_value) || '';
        } catch (ex) {
          // eslint-disable-next-line
          console.error(ex);
        }
        return msg;
      }
    });

    this.AllMessages = {}; // 用于保存所有的文案，{ key, value } 键值对形式
    this.momentTimezone = _momentTimezone2.default; // 已经废弃，保留版本向前兼容
    this.currentLocale = this.getDefaultLocale();
    this.dateOptions = this.getDefaultDateOptions();
    this.reset(); // 初始默认文案
  }

  /**
   * 获取默认的locale
   * @returns {string}
   */


  _createClass(IotIntl, [{
    key: 'getDefaultLocale',
    value: function getDefaultLocale() {
      // 默认使用 zh，其实应该是 en，但因为中文站优先级最高，还是用 zh
      var defaultVal = 'zh';

      // OneConsole 逻辑
      if (window.ALIYUN_CONSOLE_CONFIG) {
        // 尝试从window中获取当前的locale
        var console_config = window.ALIYUN_CONSOLE_CONFIG || {};
        var LANG = console_config.LANG;

        if (LANG && ['zh', 'en', 'ja'].includes(LANG)) {
          defaultVal = LANG;
        }
      }

      return defaultVal;
    }

    /**
     * 获取默认的时间打印格式
     * @returns {{en: {month: string, hour: string, year: string, timeZone: *, hourCycle: string, day: string, hour12: boolean, minute: string, second: string}, zh: {month: string, hour: string, year: string, timeZone: *, hourCycle: string, day: string, hour12: boolean, minute: string, second: string}}}
     */

  }, {
    key: 'getDefaultDateOptions',
    value: function getDefaultDateOptions() {
      // 获取当前 time zone
      var timeZone = _momentTimezone2.default.tz.guess();

      // 当前只支持 en 与 zh 两种时间格式，缺省情况使用 zh
      var options = {
        zh: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          // 需要显示加上，兼容低版本浏览器上需要加上，否则会走true值
          hour12: false,
          // Hour system using 0–23; corresponds to 'H' in patterns. The 24 hour clock, with midnight starting at 0:00.
          // @see https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Locale/hourCycle
          hourCycle: 'h23',
          timeZone: timeZone
        },
        en: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          // 需要显示加上，兼容低版本浏览器上需要加上，否则会走true值
          hour12: false,
          // Hour system using 0–23; corresponds to 'H' in patterns. The 24 hour clock, with midnight starting at 0:00.
          // @see https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Locale/hourCycle
          hourCycle: 'h23',
          timeZone: timeZone
        }
      };

      // 浏览器兼容方案
      // https://support.google.com/chrome/thread/29828561?hl=en
      // 当前 work around 是移除 hour12 属性
      var isSpecialHandling = browser.satisfies({ chrome: '>=80', opera: ">=22", edge: '>=11' });
      if (isSpecialHandling) {
        delete options.en.hour12;
        delete options.zh.hour12;
      }

      return options;
    }

    /**
     * 重置当前对象中的文案到默认集合
     */


    /**
     * 美杜莎key和默认messages注册, 当没有美杜莎全局引用时会启用默认messages
     * @param appName
     * @param defaultMessages
     */


    /**
     * 增加文案到当前对象中
     * @param messages
     */


    /**
     * 获取当前的locale值
     * @returns {string}
     */


    /**
     * 设置当前的locale，目前支持 en，zh，ja
     * @param locale
     */


    /**
     * 美杜莎输出的文案中locale对应的值是 en_US/zh_CN/ja_JP 的形式
     * 这里是从当前的locale转换到美杜莎对应的值
     * @returns {string}
     */


    /**
     * 时间格式化
     * @param date
     * @param options
     * @returns {string}
     */


    /**
     * 文案翻译
     * @param id
     * @param value
     * @returns {*|string}
     */

  }, {
    key: 'loadDefaultMsg',


    /**
     * 对类似OneConsole系统文案机制的兼容处理
     * 在切换locale时会做一次加载尝试
     * 详细参考文档：http://ax.aliyun-inc.com/onebook/declare/mcmsNew.html
     * 
     */
    value: function loadDefaultMsg(locale) {
      // 清空当前文案
      this.AllMessages = {};
      // 尝试从ALIYUN_CONSOLE_I18N_MESSAGE中加载
      // 如果ALIYUN_CONSOLE_I18N_MESSAGE已经包含了文案，不对下面两种情况做处理
      // ALIYUN_CONSOLE_I18N_MESSAGE 已经是oneconsole处理后的结果
      if (window.ALIYUN_CONSOLE_I18N_MESSAGE) {
        this.addMessages(window.ALIYUN_CONSOLE_I18N_MESSAGE);
        return;
      }

      // 尝试从iot-console-aliyun-com中获取文案
      // 对应到OneConsole中的美杜莎非CDN方案
      if (window['iot-console-aliyun-com']) {
        var obj = window['iot-console-aliyun-com'];
        var _obj$en_US = obj.en_US,
            en_US = _obj$en_US === undefined ? {} : _obj$en_US,
            _obj$zh_CN = obj.zh_CN,
            zh_CN = _obj$zh_CN === undefined ? {} : _obj$zh_CN,
            _obj$ja_JP = obj.ja_JP,
            ja_JP = _obj$ja_JP === undefined ? {} : _obj$ja_JP;

        var messages = { en: en_US, zh: zh_CN, ja: ja_JP }[locale] || {};
        this.addMessages(messages);
        return;
      }

      // 尝试从 iot-console-aliyun-com_${locale_key} 中加载
      // 对应到OneConsole中的美杜莎CDN方案
      var locale_key = { en: 'en_us', zh: 'zh_cn', ja: 'ja_jp' }[locale] || '';
      if (window['iot-console-aliyun-com_' + locale_key]) {
        this.addMessages(window['iot-console-aliyun-com_' + locale_key]);
      }
    }
  }]);

  return IotIntl;
}();

exports.default = IotIntl;
module.exports = exports.default;